import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { saveGeneralSettingsFailed, saveGeneralSettingsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import loadGeneralSettings from './loadGeneralSettings';
import loadStatus from '../../System/sagas/loadStatus';

export default function* saveGeneralSettings(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/complex-data`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(saveGeneralSettingsSuccessful(data));
      yield call(loadGeneralSettings, {});
      yield call(loadStatus, {});
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(saveGeneralSettingsFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(saveGeneralSettingsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
